import { useCallback, useEffect, useState } from 'react';

export interface StatusMessage {
  text: string;
  /** Muda a cada aviso: mesmo texto repetido ("Nota apagada." duas vezes) precisa ser anunciado de novo. */
  id: number;
}

/** Tempo que um aviso de sucesso fica na tela (o leitor de tela já o anunciou ao aparecer). */
export const STATUS_VISIBLE_MS = 10_000;

/**
 * Aviso de resultado ("Conversa assumida por você.") para uma região `role="status"`. Some sozinho:
 * um "Conversa liberada." eterno viraria informação velha quando outra pessoa mexer na conversa.
 */
export function useStatusMessage(visibleMs = STATUS_VISIBLE_MS) {
  const [message, setMessage] = useState<StatusMessage>({ text: '', id: 0 });

  const announce = useCallback((text: string): void => {
    setMessage((previous) => ({ text, id: previous.id + 1 }));
  }, []);

  useEffect(() => {
    if (!message.text) return;
    const timer = setTimeout(() => {
      // Só apaga o aviso que armou este temporizador (um aviso mais novo tem o seu).
      setMessage((current) => (current.id === message.id ? { ...current, text: '' } : current));
    }, visibleMs);
    return () => clearTimeout(timer);
  }, [message, visibleMs]);

  return { message, announce };
}
